// Entry to a ride. The session, the HUD, the coach, the results screen and the world builders load on demand as one
// chunk the first time a ride starts: the screens that offer a ride stay light, and the app opens faster.
type Session = typeof import('./session.js');

let loaded: Session | null = null;
let loading: Promise<Session> | null = null;
const load = () => (loading ??= import('./session.js').then(m => (loaded = m)));

/** Starts a race or a workout (see session.ts startRide for the configuration). */
export async function startRide(cfg: Parameters<Session['startRide']>[0]): Promise<void> {
  return (await load()).startRide(cfg);
}

/** True while a ride is in progress; false until any ride ever started. */
export const isRiding = (): boolean => !!loaded?.isRiding();
